/* Built In Imports */
import NextLink from 'next/link';

/* External Imports */
import { Box, Link, Text, useBreakpointValue } from '@chakra-ui/react';

/* Internal Imports */
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
import { useContextualRouting } from '../../hooks/useContextualRouting';

/* Mixpanel for SEO*/
import { mixPanel } from '@utils/Mixpanel';
import { useRouter } from 'next/router';


/* Services */
// import { consoleLog } from '@components/Utility/Shared/SharedService';

/**
 * Renders the Upcoming ProgramCard component
 *
 * @param {object} sectionContent - Content from API.
 * @param {number} number - Big image to show.
 * @param {string} region - Current User country?.
 * @param {string} lang - Current User Language.
 * @param {object} apiType - Api Type of component
 * @returns {ReactElement} Upcoming Program Card component
 */

const UpcomingProgramCard = ({
  sectionContent,
  number,
  count,
  apiType,
  region,
  lang,
  LinkInNewTab,
  mompage,
  programtype,
}) => {
  // let programReady = (process.env.SSR_MODE || process.env.SSR_MODE === '1' || process.env.NEXT_PUBLIC_SSR_MODE === '1' || config.ENV_NAME === 'dev') ? true : false; // ? if program api ready make it true
  const { makeContextualHref } = useContextualRouting();
  const variant = useBreakpointValue({ md: 'md' });
  const router = useRouter();

  let content =
    sectionContent &&
    (number === 0
      ? sectionContent[count.toString()]
      : sectionContent[number.toString()]);

  const handleClick = content => {
    let tempProgUrl = '';
    let progUrl = '';
    const registerUrl = content?.register_url?.trim();
    if (registerUrl && (LinkInNewTab === true || LinkInNewTab === 'true')) {
      progUrl = refineUrlDomain(content?.register_url);
    }
    else {
    if (apiType === 'macro') {
      tempProgUrl = `${
        config.BASE_PATH
      }/${region}/${lang}/redirect-to-site?link=${encodeURI(
        content?.program_url
      )}`;
      progUrl = refineUrlDomain(tempProgUrl);
    } else {
      progUrl =
        variant === 'md'
          ? makeContextualHref({ id: content?.program_id })
          : refineUrlDomain(content?.program_url);
    }
  }
    return progUrl;
  };

 // Mixpanel
  const mixpanelevent = () => {
    let program_type = "";
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    const cleanValue = (value) => value?.replace(/-/g, ' ') || null;
    if(pathSegments.length >= 5){
      program_type = cleanValue(pathSegments[3]);
    }
    const Mixpanel = mixPanel(window?.location.pathname);
    Mixpanel.track("yoga_meditation_program_finder_card_click", {
      program_name: content?.title,
      //program_type: program_type ? program_type : "",
      //master_program:router?.query?.sourcem ? router?.query?.sourcem : "",
      program_source:router?.query?.source ? router?.query?.source : "direct",
      program_language:content?.language,
      program_location: content?.address,
      program_date: content?.date,
      page_name: "Program Details Page",
     });
  }
 // Mixpanel

  const handleAsLink = content => {
    let progUrl = '';
    const registerUrl = content?.register_url?.trim();
    if (registerUrl && (LinkInNewTab === true || LinkInNewTab === 'true')) {
      progUrl = refineUrlDomain(content?.register_url);
    }
    else {
      if (apiType === 'macro') {
        progUrl = `${
          config.BASE_PATH
        }/${region}/${lang}/redirect-to-site?link=${encodeURI(
          content?.program_url
        )}`;
      } else {
        progUrl = `/${region}/${lang}/program-details?id=${content.program_id}`;
      }
    }
    return progUrl;
  };

  return content ? (
    <NextLink
      href={handleClick(content)}
      as={handleAsLink(content)}
      passHref
      scroll={false}
      shallow
      legacyBehavior
    >
      <Link
        _hover={{
          textDecoration: 'none',
        }}
        // target={apiType === 'macro' ? '_blank' : ''}
        target={LinkInNewTab === true && content?.register_url?.trim() || apiType === 'macro' ? "_blank" : ''}
      >
        <Box
          position="static"
          boxShadow={(mompage) ? '0px 42px 89.8px 0px #99C0FF0D, 0px 167px 165.4px 0px #99C0FF0D, 0px 377px 226px 0px #99C0FF0A, 0px 669px 268px 0px #99C0FF03, 0px 1046px 249.8px 0px #99C0FF00' : "0 0 16px 0 rgb(0 0 0 / 15%)"}
          minHeight="261px"
          // marginBottom="3vw"
          backgroundColor={(mompage) ? '#FFFFFF0A' : "White"} 
          textAlign="left"
          color={(mompage) ? '#FFFFFF99': "black"}
          margin={{ base: '0 auto', md: 'inherit' }}
          onClick={()=> mixpanelevent()}
        >
          <Box backgroundColor={(mompage) ? '#FFFFFF' :"rgb(234 227 212)"} h="202px">
            <Box
              fontFamily="FedraSansStd-A-medium"
              minHeight="125px"
              backgroundColor={(mompage) ? '#191D23' : 'rgb(174 69 17)'}
              color={(mompage) ? '#ffffff' : "rgb(255 255 255)"}
              fontSize={{ base: '20px', md: '16px', xl: '20px' }}
              lineHeight="1.1"
              width={(mompage) ? '101%' : 'auto'}
              marginTop={(mompage) ? '-1px' : '0'}
              padding="20px 16px 20px 16px"
              clipPath="polygon(0 0, 100% 0, 100% 100%, 0 90%)"
            >
              {content?.title}
            </Box>

            <Box
              fontFamily="FedraSansStd-medium"
              fontSize="16px"
              padding="0 15px 15px"
            >
              <Text as="span" color={(mompage) ? '#28231E' : ''}>{content?.date}</Text>
              {content?.language?.toLowerCase() !== 'unspecified' && (
                <Box fontFamily="FedraSansStd-book" color={(mompage) ? '#EC1C2D' : ''} fontSize="14px">
                  {toTitleCase(content?.language)}
                </Box>
              )}
            </Box>
          </Box>
          <Box
            fontFamily="FedraSansStd-book"
            fontSize="14px"
            padding="15px 0 15px 15px"
          >
            {content?.address ? `${content?.address}, ` : ''}
            {content?.city ? `${content?.city}, ` : ''}
            {content?.state ? `${content?.state}, ` : ''}
            {content?.country ? `${content?.country}` : ''}
          </Box>
        </Box>
      </Link>
    </NextLink>
  ) : (
    ''
  );
};

// helpers
const toTitleCase = str =>
  str?.replace(
    /(^\w|\s\w)(\S*)/g,
    (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
  );

export default UpcomingProgramCard;
